import init from '../../helpers/init';

const {$} = init;
const BX = (<any>window).BX;

$(() => {
  let $modal = $('.js-load-modal-tickets-question');
  if ($modal.length) {
    let $btnY = $modal.find('.js-btn-yes-tickets-question');
    let $btnN = $modal.find('.js-btn-no-tickets-question');

    // Явно указываем типы переменных
    let isProcessing: boolean = false;
    let pendingLink: string | null = null;
    let pendingTicketCode: string | null = null;
    let shouldOpenInNewTab: boolean = false; // Флаг для открытия в новой вкладке

    // Типизируем ответ от сервера
    interface AjaxResponse {
      success: boolean;
      data?: {
        showPopup?: boolean;
      };
      errors?: string[];
    }

    // Функция для открытия ссылки
    function navigateToLink(link: string, openInNewTab: boolean = false): void {
      if (openInNewTab) {
        // Открываем в новой вкладке
        window.open(link, '_blank');
      } else {
        // Открываем в текущей вкладке
        window.location.href = link;
      }
    }

    // Функция обработки ответа пользователя
    function handleAnswer(answer: 'Y' | 'N'): void {
      if (isProcessing || !pendingLink || !pendingTicketCode) return;

      isProcessing = true;
      const ticketCode: string = pendingTicketCode;
      const link: string = pendingLink;
      const openInNewTab: boolean = shouldOpenInNewTab;

      // Закрываем модальное окно
      $modal.modal('hide');

      // Убираем aria-hidden при закрытии
      setTimeout(() => {
        $modal.removeAttr('aria-hidden');
      }, 100);

      // Отправляем ответ
      BX.ajax.get('/local/ajax/public/Tickets/setTicketsQuestionAnswer/', {
        ticketCode: ticketCode,
        answer: answer,
      }, (response: any) => {
        isProcessing = false;

        try {
          let result: AjaxResponse = JSON.parse(response);
          if (!BX.Type.isObject(result)) {
            console.error('Unknown response');
          } else if (!result.success && result.errors) {
            console.error(result.errors);
          }
        } catch (e) {
          console.error('Parse error:', e);
        }

        // Устанавливаем cookie, чтобы вопрос больше не показывался
        BX.setCookie('ticketQuestion' + ticketCode, 'Y', {
          expires: 365,
          path: '/'
        });

        // Выполняем переход по ссылке (в новой или текущей вкладке)
        navigateToLink(link, openInNewTab);

        // Сбрасываем состояние
        pendingLink = null;
        pendingTicketCode = null;
        shouldOpenInNewTab = false;
      });
    }

    // Назначаем обработчики для кнопок (один раз)
    $btnY.off('click.modalHandler').on('click.modalHandler', function(this: HTMLElement) {
      handleAnswer('Y');
    });

    $btnN.off('click.modalHandler').on('click.modalHandler', function(this: HTMLElement) {
      handleAnswer('N');
    });

    // Обработчик кликов по ссылкам
    $(document).on('click', 'a[href*="/tikets/?CODE="]', function(this: HTMLAnchorElement, e: JQuery.ClickEvent) {
      return;

      // Если есть ожидающий ответ - блокируем новые клики
      if (pendingLink) {
        e.preventDefault();
        return;
      }

      const href: string = this.getAttribute('href') || '';
      const target: string = this.getAttribute('target') || '';
      const uri = new BX.Uri(href);
      const ticketCode: string | null = uri.getQueryParam('CODE');

      // Проверяем наличие ticketCode и cookie
      if (!ticketCode || BX.getCookie('ticketQuestion' + ticketCode)) {
        return; // Пропускаем, переход будет выполнен
      }

      e.preventDefault();

      // Определяем, нужно ли открывать в новой вкладке
      const openInNewTab: boolean = target === '_blank' || e.metaKey || e.ctrlKey;

      // Показываем индикатор загрузки
      BX.showWait();

      // Проверяем, нужно ли показывать вопрос
      BX.ajax.get('/local/ajax/public/Tickets/isNeedTicketsQuestion/', {
        ticketCode: ticketCode,
      }, (response: any) => {
        BX.closeWait();

        try {
          let result: AjaxResponse = JSON.parse(response);

          if (!BX.Type.isObject(result)) {
            console.error('Unknown response');
            // При ошибке переходим по ссылке
            navigateToLink(href, openInNewTab);
            return;
          }

          if (result.success && result.data && result.data.showPopup) {
            // Сохраняем ссылку, код и флаг для последующего перехода
            pendingLink = href;
            pendingTicketCode = ticketCode;
            shouldOpenInNewTab = openInNewTab;

            // Открываем модальное окно
            $modal.modal('show');

            // Убираем aria-hidden и переводим фокус
            setTimeout(() => {
              $modal.removeAttr('aria-hidden');
              $btnY.focus();
            }, 150);
          } else {
            // Если показывать не нужно - переходим по ссылке
            navigateToLink(href, openInNewTab);
          }
        } catch (e) {
          console.error('Parse error:', e);
          navigateToLink(href, openInNewTab);
        }
      });
    });

    // Обработчик закрытия модального окна
    $modal.on('hidden.bs.modal', function() {
      // Устанавливаем aria-hidden при закрытии
      $modal.attr('aria-hidden', 'true');

      // Если модалка закрыта без ответа (пользователь закрыл сам)
      // и нет активной обработки - сбрасываем состояние, НЕ переходя по ссылке
      if (pendingLink && !isProcessing) {
        console.log('Модальное окно закрыто без ответа, переход отменен');
        pendingLink = null;
        pendingTicketCode = null;
        shouldOpenInNewTab = false;
      }
    });

    // Обработчик открытия модального окна
    $modal.on('shown.bs.modal', function() {
      $modal.removeAttr('aria-hidden');
      setTimeout(() => {
        $btnY.focus();
      }, 50);
    });

    // Обработчик закрытия по Escape
    $(document).on('keydown', function(e: JQuery.KeyDownEvent) {
      if (e.key === 'Escape' && $modal.hasClass('show')) {
        $modal.modal('hide');
        // Обработчик hidden.bs.modal сбросит pendingLink
      }
    });
  }
});
